export function nopropagation(event){event.stopImmediatePropagation()}export default function(event){event.preventDefault(),event.stopImmediatePropagation()}